import React from 'react';

export default function DaySummary({
  t,
  selectedDate,
  selectedLunar,
  localizedDayName,
  localizedCanChiYear,
  lunarStemBranchLines,
  weekdayLabel
}) {
  return (
    <div className="card day-summary-card">
      <div className="section-header">
        <h3 className="section-title">{t.dailyCalendar}</h3>
      </div>
      {selectedDate ? (
        <div className="day-summary-grid">
          <div className="day-summary-column">
            <p className="chip-label">{t.solar}</p>
            <p className="day-summary-month">
              {`${t.monthNames[selectedDate.getMonth()]} ${selectedDate.getFullYear()}`}
            </p>
            <p className="day-summary-day">{selectedDate.getDate()}</p>
            <p className="day-summary-subtext">{weekdayLabel}</p>
          </div>

          <div className="day-summary-column">
            <p className="chip-label">{t.lunar}</p>
            <p className="day-summary-month">
              {selectedLunar
                ? `${t.lunarMonthLabel} ${selectedLunar.month} · ${t.lunarYearLabel} ${selectedLunar.year}`
                : '--'}
            </p>
            <p className="day-summary-day">{selectedLunar?.day || '--'}</p>
            <p className="day-summary-subtext">{localizedDayName || localizedCanChiYear}</p>

            {lunarStemBranchLines.length > 0 && (
              <div className="day-summary-can-chi">
                {lunarStemBranchLines.map((item) => (
                  <div key={item.label} className="can-chi-chip">
                    <p className="chip-label">{item.label}</p>
                    <p className="chip-value">{item.value}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <p className="muted-text">{t.selectDate}</p>
      )}
    </div>
  );
}
